// extracted by mini-css-extract-plugin
export default {"w-full":"Theme_w-full__RYUEG","theme":"Theme_theme__hrgiE"};